import axios from "@/plugins/axios";

let url = "/api/v1/portfolios/estimate-inquiries";

export default {
    postEstimateInquiry(data) {
        return axios.post(url, data).then(result => result.data);
    },
    postImage(data, image) {
        var formData = new FormData();
        formData.append("image", image);
        var headers = {
            "Content-Type": "multipart/form-data"
        };
        return axios.post(`${url}/${data._id}/image`, formData, {
            headers
        }).then(result => result.data);
    },
}